import { Skeleton } from "@/components/ui/skeleton";

export const LibrarySkeleton = () => {
  return (
    <main className="flex-1 p-3 md:p-6 pb-16 flex justify-center overflow-y-auto">
      <div className="w-full max-w-[1200px] space-y-3 pb-16" role="status" aria-label="Ładowanie biblioteki">
        {/* Tabs - matches glass-card inline-flex */}
        <div className="inline-flex flex-wrap gap-1 rounded-xl border border-border/50 p-1">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} className="h-8 w-20 rounded-lg" />
          ))}
        </div>

        {/* Content cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="rounded-xl border border-border/50 p-4 space-y-3">
              <div className="flex items-center justify-between">
                <Skeleton className="h-5 w-12 rounded-full" />
                <Skeleton className="h-3 w-20" />
              </div>
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-5/6" />
              <div className="flex gap-2 pt-2">
                <Skeleton className="h-8 w-8 rounded-full" />
                <Skeleton className="h-8 w-8 rounded-full" />
                <Skeleton className="h-8 w-8 rounded-full" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};
